import { ReactElement } from 'react';
import { Modal, ModalFooter } from '@sc/shared-ui';

interface Props {
  open: boolean;
  url: string;
  onClose: () => void;
}

export const ProjectPublishedModal = ({
  open,
  url,
  onClose,
}: Props): ReactElement => (
  <Modal
    open={open}
    onClose={onClose}
    icon="success"
    title="Your knowledge base is live!"
    dialogPanelClassname="w-120"
  >
    <div className="px-5 pb-5 pt-1">
      <p className="text-base leading-6 text-text-low-priority">
        Nice work — give it a spin at{' '}
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary-400 underline break-all"
        >
          {url}
        </a>
      </p>
    </div>
    <ModalFooter
      submitText="Try now"
      closeText="Close"
      onSubmit={() => {
        window.open(url, '_blank', 'noopener,noreferrer');

        onClose();
      }}
      onClose={onClose}
    />
  </Modal>
);
